<template>
    <div class="pb-1 text-small">
        <form :id="`container-${identifier}`">
            <div @click="activateSelection" >
            <span class="display"
                  :class="{
                        'bg-disabled': !editable,
                        'bg-white': editable
                    }"
                  v-show="!collapsed || !editable"
            >{{ displayValue }}</span>
                <input type="text" :id="`select-${identifier}`"
                       class="custom-select custom-select-sm custom_select_icon py-1 pl-3"
                       :placeholder="`--- SELECT VESSEL ---`"
                       autocomplete="off"
                       v-model="searchString"
                       :required="required"
                       :disabled="!editable"
                       :readonly="!editable"
                       @keydown="navigate"
                       @focus="selectAll"
                >
            </div>
            <ul :id="`selection-${identifier}`"
                class="list-group position-absolute overflow-auto selection"
                :class="{'d-none' : !editable}"
            >
<!--                <li class="list-group-item p-2" id="identifier-blank"-->
<!--                    :class="{-->
<!--                    'temporary-selected-background': null == temporarySelected,-->
<!--                    'selected-background': null == value-->
<!--                }"-->
<!--                    @click="setSelected(null)"-->
<!--                    @mouseover="setTemporarySelected(null)"-->
<!--                >-&#45;&#45; SELECT VESSEL -&#45;&#45;</li>-->
                <li class="list-group-item p-2"
                    :id="`${identifier}-${option[objectKey]}`"
                    :class="{
                    'temporary-selected-background': option[objectKey] == temporarySelected,
                    'selected-background': option[objectKey] == value
                }"
                    v-for="option in options" :key="option[objectKey]"
                    @mouseover="setTemporarySelected(option[objectKey])"
                    @click="setSelected(option)"
                >{{ option[display] }}</li>

                <li class="list-group-item p-2 cursor-pointer font-weight-bold"
                    v-if="!executedOther && (isPrincipal || isStargate)"
                    :class="{
                    'temporary-selected-background': 'other' == temporarySelected,
                }"
                    @mouseover="setTemporarySelected('other')"
                    title="SHOW OTHERS"
                    @click="executeOther"
                > OTHERS <span class="ml-3 fas fa-plus"></span> </li>
            </ul>
        </form>
    </div>
</template>

<script>

import { EventBus } from "@/main";
import { gateMixin } from "@/mixins/gateMixin";

export default {
    name: "VesselDropdown",

    data() {
        return {
            collapsed: false,
            options: [],
            temporarySelected: null,
            searchString: '',
            executedOther: false
        }
    },

    mixins: [ gateMixin ],

    props: {
        selections: {
            type: Array,
            default() {
                return []
            }
        },

        value: {
            type: Number,
            default() {
                return null;
            }
        },

        objectKey: {
            type: String,
            default() {
                return 'id';
            }
        },

        display: {
            type: String,
            default() {
                return 'name';
            }
        },

        identifier: {
            type: String,
            default() {
                return '';
            }
        },

        editable: {
            type: Boolean,
            default() {
                return true;
            }
        },

        otherFunction: {
            type: Function,
            default() {
                return null;
            }
        },

        required: {
            type: Boolean,
            default() {
                return false;
            }
        }

    },

    methods: {

        closeDropdown(source) {
            if(this.collapsed) {
                let node = source.target;
                let included = false;
                while (node.parentElement) {
                    if(node.id === `container-${this.identifier}`) {
                        included = true;
                        break;
                    }
                    node = node.parentElement;
                }
                if(!included) this.collapse();
            }
        },

        activateSelection() {
            if(!this.collapsed) {
                this.collapse();
            }
        },

        collapse() {
            if(this.editable) {
                let checkboxes = document.getElementById(`selection-${this.identifier}`);
                if(!this.collapsed) {
                    checkboxes.style.display = "block";
                    this.collapsed = true;
                    this.searchString = this.displayValue;
                    this.options = this.selections;
                    setTimeout(() => {
                        document.getElementById(`select-${this.identifier}`).focus();
                    }, 100);
                } else {
                    checkboxes.style.display = "none";
                    this.collapsed = false;
                }
            }
        },

        setTemporarySelected(objectKey) {
            this.temporarySelected = objectKey;
            // document.getElementById(`select-${this.identifier}`).focus();
        },

        setSelected(option) {
            if(option) {
                this.selected = option[this.objectKey];
                this.selectionString = option[this.display];
                this.collapse();
                this.$emit('input', option[this.objectKey]);
            } else {
                this.selected = null;
                this.selectionString = '';
                this.collapse();
                this.$emit('input', null);
            }
        },

        navigate(source) {
            let index = this.options.findIndex(option => option[this.objectKey] == this.temporarySelected);
            let list = null;
            switch (source.keyCode) {
                case 13:
                    source.preventDefault();
                    let selectionObject = this.options.find(option => option[this.objectKey] == this.temporarySelected);
                    this.setSelected(selectionObject);
                    break;
                case 38: // UP ARROW
                    if(index <= 0) {
                        index = 1;
                    }
                    this.temporarySelected = this.options[--index][this.objectKey];
                    list = document.getElementById(`${this.identifier}-${this.options[index][this.objectKey]}`);
                    if(this.checkListPosition(index)) {
                        document.getElementById(`${'selection-' + this.identifier}`).scrollBy(0, -list.offsetHeight);
                    }
                    break;
                case 40:
                    if(index < 0) {
                        index = -1;
                    }
                    this.temporarySelected = this.options[++index][this.objectKey];
                    list = document.getElementById(`${this.identifier}-${this.options[index][this.objectKey]}`);
                    if(this.checkListPosition(index)) {
                        document.getElementById(`${'selection-' + this.identifier}`).scrollBy(0, list.offsetHeight);
                    }
                    break;
                default:
                    if((source.key.length === 1 || source.keyCode === 8) && !source.ctrlKey) {
                        setTimeout(() => {
                            if (!this.searchString) this.options = this.selections;
                            this.updateOptions();
                        }, 100);
                    }
                    break;
            }
        },

        checkListPosition(index) {
            let rangePosition = $(`#${this.identifier}-${this.options[index][this.objectKey]}`).offset().top - $(`#${'selection-' + this.identifier}`).offset().top;
            if(rangePosition < 0 || rangePosition > 270) {
                return true;
            }
            return false;
        },

        updateOptions() {
            this.options = this.selections.filter(selection => {
                if (!this.collapsed) {
                    this.collapse();
                }
                return selection.name.includes(this.searchString.toUpperCase());
            });

            this.temporarySelected = this.options.length ? this.options[0][this.objectKey] : null;
        },

        selectAll() {
            document.getElementById(`select-${this.identifier}`)
                .setSelectionRange(0, this.searchString.length);
        },

        async executeOther() {
            this.executedOther = true;
            await this.otherFunction();
        },
    },

    computed: {

        displayValue() {
            let vessel = '--- SELECT ---';
            if(this.value) {
                let v = this.options.find(option => {
                    return option[this.objectKey] === this.value;
                });
                if(v) vessel = v.name;
            }
            return vessel;
        },

    },

    created() {
        this.options = Object.assign([], this.selections);
        EventBus.$on('clicked', source => {
            this.closeDropdown(source);
        })

    },

  watch: {
      'selections.length'() {
        this.options = Object.assign([], this.selections);
      }
  }
}
</script>

<style scoped>

.selection {
    display: none;
    border: 1px #dadada solid;
    z-index: 2;
    max-height: 300px;
    min-width: 120%;
    position: relative;
}

.selected-background {
    background-color: #D3D3D3;
}

.temporary-selected-background {
    background-color: #add8e6;
}

.custom-select, .custom-select-sm, .custom_select_icon {
  background: #fff url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB/UlEQVR4nO3Y2atNYRgH4OfCPGTqFCFjOkkZUnSSMtwYciFFkpxSSnHt3l/gxj/gwo0oKUlSkpI5EolQhMg8D0dfrVOnU2fv7zjWns771Hu11/p+7/vtvdfeaxFCCCGEEEIIIYQQQsiwGJ1YjaHqZzg2Yi86ahE4BEfQ1aOuYo7aa8ftXr0cw4gyQw/0Cuyup5ildubheR+9HCwz+GYfoameYKbyzcDjCn1cLzP8foXgVA8wtY7Dp7pbYr7DVcJT3cPkErKn4WFG/iElmlR836s1cQdt/zF3SsanL9UjjFeyuXiW0cytYsMGqq3Y0Gp56Y2ZrQGuwl096gYmDiBnQnFRq5bzovhZrKn2Irhac9eKQforfZSvZKz/EvPVyUK8zmjyEsb2Y91xuJyx7issUGeL8Caj2YsYk7HeaFzIWO8tlmgQy/E+o+mzGFlhnVE4n7HOOyzVYDrwMaP5M338X08bcy7j/LTRyzSoFfiUMcTp4k6u2zCcyjjvM1ZqcGvxNWOY48WtdBr+ZObwqzSJ9fieMdRRnMg47gvWaDLr8C1juGqVNnKDJrUZPwcw/A9s0uS2/OMm/MJWLWInfvdz+O1aTGfmJqRjdmhRu/GnwvDptT1a3P4Kw6fH24PCvuIK3z38B+wyyEwvLnTbikdeIYQQQgghhBBCCCEEpfsLGA+D9itjtm0AAAAASUVORK5CYII=") no-repeat right .75rem center/15px 15px;
}

.display {
    margin: 2px;
    position: absolute;
    padding: 4px 0px 4px 16px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 80%;
}
</style>